import { createEvent, createStore, sample } from 'effector';
import type { SortDir } from './clients-filter.entity';
import { $resetAuth } from './profile-entity';

export interface IPush {
	id: number;
	clientId: string;
	buildId: string;
	packageName: string;
	title: string;
	text: string;
	takeStatus?: 0 | 1 | 2 | 3;
	takenFrom?: string;
	comment?: string;
	createdAt: string | number;
	isOnline?: boolean;
	hasPhone?: boolean;
	phoneCountryCodes?: import('@crave/config/phone-country').PhoneCountryCode[];
	hasUnclassifiedNonEmptyPhone?: boolean;
}

export const $resetPanelState = createEvent();

export const $setIsFetchingPushes = createEvent<boolean>();
export const $isFetchingPushes = createStore<boolean>(false).on($setIsFetchingPushes, (_, payload) => payload).reset($resetPanelState);

export const $setHasMorePushes = createEvent<boolean>();
export const $hasMorePushes = createStore<boolean>(false).on($setHasMorePushes, (_, payload) => payload).reset($resetPanelState);

export const $setCursorPushes = createEvent<string | null>();
export const $cursorPushes = createStore<string | null>(null).on($setCursorPushes, (_, payload) => payload).reset($resetPanelState);

export const $setPushes = createEvent<IPush[]>();
export const $newPush = createEvent<{ push: IPush; sortDir: SortDir }>();
export const $addPushes = createEvent<IPush[]>();
export const $updatePushesByClientId = createEvent<Partial<IPush> & { clientId: string }>();

export const $pushes = createStore<IPush[]>([])
	.on($setPushes, (_, payload) => payload)
	.on($addPushes, (state, payload) => {
		if (!payload.length) return state;
		const existingIds = new Set(state.map(item => item.id));
		const fresh = payload.filter(item => !existingIds.has(item.id));
		return fresh.length ? [...state, ...fresh] : state;
	})
	.on($newPush, (state, { push, sortDir }) => {
		if (state.some(item => item.id === push.id)) return state;
		return sortDir === 'asc' ? [...state, push] : [push, ...state];
	})
	.on($updatePushesByClientId, (state, payload) =>
		state.map(item => (item.clientId === payload.clientId ? { ...item, ...payload, id: item.id } : item)),
	)
	.reset($resetPanelState);

sample({
	clock: $resetAuth,
	target: $resetPanelState,
});
